import { Controller } from '@hotwired/stimulus'
import Modal from 'components/modal'

export default class extends Controller {
  static values = {
    sessionId: String
  }

  initialize() {
    if (navigator.cookieEnabled && window.localStorage) {
      window.localStorage.setItem("quimbee-masked-session-id", this.sessionIdValue)
    }
  }

  onLocalStorageChange(evt){
    if(evt.key === "quimbee-masked-session-id" && evt.newValue !== this.sessionIdValue) {
      console.log("Detected a session change. Id from original request was ", this.sessionIdValue, " and now id in localStorage is", evt.newValue)
      Modal.show("sessionChangedModal")
    }
  }
}
